import { render, staticRenderFns } from "./MemberFeedTab.vue?vue&type=template&id=7f2291f8&"
import script from "./MemberFeedTab.vue?vue&type=script&lang=js&"
export * from "./MemberFeedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports